var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCentralAfricanRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0549 8.34779C27.9874 4.55848 24.4322 1.69792 20.1743 0.550293L19.4786 8.34779H30.0549Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94544 8.34779H12.5217L11.8261 0.550293C7.56813 1.69792 4.013 4.55854 1.94544 8.34779Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 16V23.6522H30.0548C31.2951 21.379 32.0003 18.7719 32.0003 16H19.4785Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 16H0C0 18.7719 0.705188 21.379 1.94544 23.6522H12.5217V16H12.5218Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94544 23.6521C4.013 27.4414 7.56813 30.302 11.8261 31.4496L12.5217 24.6303L1.94544 23.6521Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1743 31.4496C24.4322 30.302 27.9874 27.4414 30.0549 23.6521L19.4786 24.6302L20.1743 31.4496Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4786 24.6302L30.0549 23.6521H19.4786V24.6302Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 23.6521H1.94544L12.5218 24.6302V23.6521Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C14.5558 0 13.1569 0.1925 11.8261 0.551188V31.4489C13.1569 31.8075 14.5558 32 16 32C17.4442 32 18.8431 31.8075 20.1739 31.4488V0.551188C18.8431 0.1925 17.4442 0 16 0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60584 3.47827L9.03747 4.80683H10.4345L9.30441 5.62796L9.73609 6.95652L8.60584 6.13546L7.47566 6.95652L7.90747 5.62796L6.77734 4.80683H8.17428L8.60584 3.47827Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCentralAfricanRepublic);
export default __webpack_public_path__ + "static/media/flag_central_african_republic.18fc73826ee370a0e6a3fe5b648bc509.svg";
export { ForwardRef as ReactComponent };